import React, {useState} from 'react';

import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from '@mui/material';

import {resetDocument} from '../../documents/editor/EditorContext';
import validateJsonStringValue from './validateJsonStringValue';

export default function ImportJsonDialog({onClose}) {
    const [value, setValue] = useState('');
    const [error, setError] = useState(null);

    const handleChange = (ev) => {
        const v = ev.currentTarget.value;
        setValue(v);
        const {error} = validateJsonStringValue(v);
        setError(error ?? null);
    };

    let errorAlert = null;
    if (error) {
        errorAlert = <Alert color="error">{error}</Alert>;
    }

    return (
        <Dialog open onClose={onClose}>
            <DialogTitle>Import JSON</DialogTitle>
            <form
                onSubmit={(ev) => {
                    ev.preventDefault();
                    const {error, data} = validateJsonStringValue(value);
                    setError(error ?? null);
                    if (!data) {
                        return;
                    }
                    resetDocument(data);
                    onClose();
                }}
            >
                <DialogContent>
                    <Typography color="text.secondary" paragraph>
                        Copy and paste the json configuration
                    </Typography>
                    {errorAlert}
                    <TextField
                        error={error !== null}
                        value={value}
                        onChange={handleChange}
                        type="text"
                        helperText="This will override your current template."
                        variant="outlined"
                        fullWidth
                        multiline
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" type="submit" disabled={error !== null}>
                        Import
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
